module.exports = __webpack_public_path__ + "static/media/MuseoSansMedium.db1355d5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansMedium/MuseoSansMedium.woff
// module id = 642
// module chunks = 0